export default "__VITE_ASSET__$pFu9ftH__"